import React, { useCallback, useEffect, useState } from 'react'
import { useWindowScroll, useWindowSize } from 'react-use'
import { DonateButton } from 'ppp'
import { StickyPhoneProps } from './types'

export const StickyPhone = (props: StickyPhoneProps): JSX.Element => {
  const [visible, setVisible] = useState(false)
  const [left, setLeft] = useState(0)

  const handleScroll = useCallback(() => {
    const triggerDistance = document.querySelector('#ppp-sticky-anchor')?.getBoundingClientRect().top ?? 0
    const unTriggerDistance = (document.querySelector('footer')?.getBoundingClientRect().top ?? 0) - window.innerHeight
    setVisible(triggerDistance <= 0 && unTriggerDistance >= 0)
  }, [])

  const handleResize = useCallback(() => {
    let bodyLeft = document.querySelector('body')?.getBoundingClientRect().left ?? 0
    if (bodyLeft < 0) bodyLeft = 0
    setLeft(bodyLeft)
  }, [])

  const { y } = useWindowScroll()
  useEffect(() => {
    y === 0 || handleScroll()
  }, [y, handleScroll])
  const { width, height } = useWindowSize()
  useEffect(() => {
    width && handleResize()
  }, [width, height, handleResize])

  return (
    <div className="phone-sticky-wrapper" style={{ opacity: visible ? 1 : 0, left: left }}>
      <div className="sticky-wrapper justify-between items-center flex">
        <DonateButton project={props.project} status={props.status} gaAction="click donate_button__sticky" />
      </div>
    </div>
  )
}
